function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sz_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.7,
  d: "M-85.3 0h682.6v512H-85.3z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sz_svg__a)",
  transform: "translate(80) scale(.9375)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3e5eb9",
  fillRule: "evenodd",
  d: "M-128 0h768v512h-768z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffd900",
  fillRule: "evenodd",
  d: "M-128 91.4h768v329.2h-768z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b10c0c",
  fillRule: "evenodd",
  d: "M-128 128h768v256h-768z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 621.7,
  height: 11,
  x: -51.4,
  y: 250.5,
  fill: "#ffd900",
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.5,
  rx: 5.8,
  ry: 5.8
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  transform: "translate(-757 -25.6) scale(1.0321)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  strokeWidth: 4.2,
  d: "M-106.3 265.8l-88.6 35.4 88.6 35.4 88.6-35.4-88.6-35.4z",
  transform: "matrix(.34 0 0 .3 1256.8 136.4)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 442.9,
  height: 7.1,
  x: 761.8,
  y: 223.2,
  fill: "#ffd900",
  fillRule: "evenodd",
  strokeWidth: 1.3,
  rx: 4.1,
  ry: 3.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1806.3 90.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1802.8 90.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1799.2 90.4)"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  transform: "translate(-786.3 -3.7) scale(1.0321)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  strokeWidth: 4.2,
  d: "M-106.3 265.8l-88.6 35.4 88.6 35.4 88.6-35.4-88.6-35.4z",
  transform: "matrix(.34 0 0 .3 1256.8 136.4)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 442.9,
  height: 7.1,
  x: 761.8,
  y: 223.2,
  fill: "#ffd900",
  fillRule: "evenodd",
  strokeWidth: 1.3,
  rx: 4.1,
  ry: 3.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1806.3 90.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1802.8 90.3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 2.7,
  d: "M1224.4 280c-3.5 0-7-3.6-7-7.2s3.5-7 7-7",
  transform: "matrix(-.50001 0 0 .5 1799.2 90.4)"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3d5da7",
  stroke: "#000",
  strokeWidth: 1.4,
  d: "M338-.4c-5.5 12.4 4.3-4.1 28.4 16.7 4.4 3.8 8.3 14 8.3 21.1-1.1-1-2-3-3.2-4.5-1.8 2.3 1.7 12.6 2.2 17.5-3.8-2.7-3.4-4-4.7-7.4.3 4-.6 15.2.9 19.4-3-1-2.8-4.1-4.3-4.8 1 4.9-1 10.1-.4 15.6-1.8-2.2-3.6-4-4.4-4.9-.1 2.6-3.3 9.4-3.4 11.9-1.5-1.2-1.9-3-2.1-4.2-1.8 3-8.3 14-8.7 17.2-5-5.7-17.8-19.5-19.5-26.9-1.5 4.2-3.6 5.6-7.8 8.7-1.7-11.7-8-24.8-4.6-34.8a84.4 84.4 0 00-6.6 5.9A67.9 67.9 0 01338-.4z",
  transform: "matrix(.9944 0 0 .77118 190.4 252)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a70000",
  d: "M505.9 299.2c2.3-4.6 4.4-6 5.9-9 2.6-5.2 3-9.4 5.3-8.8 2.3.6 2.3 2.8-.7 7.9-3 5-4.4 6.2-10.5 9.9zm15.5 11c-.3-3.6.8-5 .6-7.3-.3-4-2-6.7.1-6.9 2.1-.2 3.1 1.2 3.1 5.2s-.6 5-3.8 9zm11.8 6.8c-.9-5-.2-7-.8-10.2-1-5.6-3-9.2-1-9.7 1.9-.5 3 1.3 3.8 6.9.7 5.6.3 7.2-2 13zm12.3-34.3c-2.9-2.1-4.6-2.3-6.4-3.7-3.3-2.5-5-5.1-6-3.8-1 1.3-.3 2.7 3.1 5 3.5 2.3 4.6 2.5 9.3 2.5zm-2 16.3c-1.5-3.2-3.1-4-4.1-6-1.8-3.6-1.8-6.7-3.6-5.9-2 .8-2 2.4 0 5.9 2 3.4 3 4 7.7 6z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3d5da7",
  stroke: "#000",
  strokeWidth: 1.4,
  d: "M329.6 20.7c-.3-2.7.3-3-1.3-5 2.2 1 2.3 3.7 5 1.8 1-.6 1.4-.6.2-3.5 2.8 0 12 3.5 13.4 3.6 3.9.2 10.9-4.4 15.7 1.2 4.7 5.1 3.1 10.4 3.1 17.5-1.8-1-1-1.4-3-4 1.6 6.2 0 17.4 0 24-.8-1.6-.7-1-1.4-2.6-2 6-4.4 7.3-4.4 14.3-.7-2.7 0-2.2-.8-3.6-2 4.5-15 8.4-10 13-4.4-2.8-6.4-2.5-8.5-5.1-.9.6-1.6 1.8-2.4 3.4-8-4-5-12.5-11.3-18.2-1 2.4-.6 2-1.8 5.9-1.2-5.4-1.6-8.9-3-12.8-1.2 2.2-1 1.3-3.3 4.7-1-6.6-2.4-8.2-1.8-12.5-2.4 1.8-.8 1-3.2 3.3 2.2-17 11.9-29.4 18.8-25.4z",
  transform: "matrix(1.1372 0 0 1.0495 -399.4 239.2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a70000",
  d: "M-35.7 289.8c2.3-5.7 4.4-7.5 6-11.2 2.6-6.4 3-11.6 5.2-10.8 2.3.8 2.2 3.4-.8 9.8a25 25 0 01-10.4 12.2zm8.8 14.3c1-5.1 2.4-7 3-10.3 1-5.8.5-10.1 2.6-9.9 2 .3 2.5 2.4 1.1 8.2-1.4 5.8-2.3 7.1-6.7 12zm10.5 9.9c.3-5 1.5-6.9 1.6-10 .3-5.7-.7-9.7 1.2-9.7 2 0 2.7 2 2.1 7.6-.6 5.6-1.3 7-4.9 12zm22.7-32.4c-4.4-4.3-7-5.1-9.8-8-4.9-4.8-7.3-9.4-9-7.7-1.8 1.6-.7 4 4.5 8.7 5.2 4.6 7 5.2 14.3 7zm-2.7 16.6C.8 294-1.2 292.8-3 290c-3.2-4.9-4.3-9.1-6-8-2 1-1.5 3.2 2 8 3.4 4.7 4.8 5.5 10.7 8.2z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 2.1,
  d: "M637.8 230.3c-53.1 59-124 177.2-265.8 177.2-124 0-212.6-118.1-265.7-177.2C159.4 171.3 248 53.2 372 53.2c141.8 0 212.6 118 265.8 177.1z",
  transform: "matrix(.68807 0 0 .61926 0 113.4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M243.2 184.4c9.8 11 1.6 15.4 12 16.1 10.8.8 4.6 11.6 13.8 12 6.4.2-.7 25.7 5.5 34.2 6.3 8.7 11.5 2.5 11.6 8.9.1 6.5-17 5.9-17.3 26-.5 11.7-14.5 12.5-15.2 20-.8 7 27.5 11 27.2 17.3-.4 6.3-30.7 5.3-32 12.4-.6 6.5 41.6 11.8 45 30.4-6.3 2-24.3 4-37.8 4-85.3 0-146.3-73.1-182.9-109.7 36.6-36.6 97.6-109.7 182.9-109.7 0 0-25.3 23.1-12.8 38.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M141.4 217h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zM177 217h8.8v29.2H177zm0 48.8h8.8V295H177zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.8-48.8h8.8v29.2h-8.8zm0 48.8h8.8V295h-8.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M275.5 217h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zM311 217h8.8v29.2H311zm0 48.8h8.8V295H311zm17.7-48.8h8.9v29.2h-9zm0 48.8h8.9V295h-9zm17.7-48.8h8.9v29.2h-8.9zm0 48.8h8.9V295h-8.9zm17.8-48.8h8.8v29.2h-8.8zm0 48.8h8.8V295h-8.8z"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3d5da7",
  stroke: "#000",
  strokeWidth: 1.4,
  d: "M338-.4c-5.5 12.4 9.8-4.1 33.8 16.7a51.2 51.2 0 0110.9 26.2c-5.1-1.2-14.2-7-14.2-7s10.6 12.2 10.6 26.4c-3.7-2.7-5.6-2.3-6.8-5.6 0 4.5 3.3 7.5 3.3 14.6a49.8 49.8 0 00-7.3-5.7c3.5 7.1-6.5 20.9-1.5 25.5-8.7-1.5-17.7-8-21.2-15-1.9 1.4-2 3.7-2.2 6.2.3.2-13.3-11.7-12-16.3-1.9 3-2.1 4.6-2.5 8a44 44 0 01-11.3-18.8l-4.6 6.7c-1.6-11.7-1.6-11.3 1.7-21.3a84.4 84.4 0 00-6.6 5.9A67.8 67.8 0 01338-.4z",
  transform: "matrix(.9094 0 0 .78749 -110.6 166.1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a70000",
  d: "M184.4 213.6c.8-6.7 2.5-9.3 3-13.6 1-7.7-.1-13.2 2.6-13.1 2.7.1 3.5 3 2.2 10.6-1.4 7.6-2.5 9.5-7.8 16.1zm14.1 12.4c-.5-5.7.5-8.1.2-11.8-.6-6.4-2.6-10.8-.3-11.2 2.4-.4 3.6 1.7 3.8 8.3.3 6.5-.3 8.2-3.7 14.7zm22.1 10c-2.4-4.8-4.5-6.3-6-9.5-2.8-5.6-3.3-10.1-5.4-9.3-2.2.8-2 3.2 1 8.7 3 5.4 4.5 6.5 10.4 10.2zm7.6-44c-6-3.3-9.2-3.3-13.2-5.4-6.9-3.6-11-7.7-12.4-5.5-1.4 2.3.5 4.5 7.7 7.8 7.1 3.3 9.3 3.5 18 3zm2.3 18.4c-4.5-3.7-7.1-4.3-10-6.7-5-4.1-7.6-8.2-9.3-6.6-1.6 1.7-.5 3.9 4.8 7.8 5.3 4 7.1 4.5 14.5 5.5z"
})));

var SvgSz = function SvgSz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2);
};

export default SvgSz;